import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Button } from '../../../../components/common/buttons/Button';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { format, getMonth } from 'date-fns';
import { monthNavigatorSlice } from '../../../../store/monthNavigatorSlice';
import { ampli } from '../../../../ampli';

export const MonthNavigator = () => {
  const { date } = useAppSelector((state) => state.monthNavigator);
  const { setPrevMonth, setNextMonth } = monthNavigatorSlice.actions;
  const dispatch = useAppDispatch();

  const year = useMemo<string>(() => {
    const currentDate = new Date(date);
    return format(currentDate, 'yy');
  }, [date]);

  const month = useMemo<number>(() => {
    const currentDate = new Date(date);
    return getMonth(currentDate) + 1;
  }, [date]);

  const handlePrevMonthButtonClick = () => {
    ampli.pvmClickMonthNavigatorButton({ button_type: 'prev' });
    dispatch(setPrevMonth());
  };

  const handleNextMonthButtonClick = () => {
    ampli.pvmClickMonthNavigatorButton({ button_type: 'next' });
    dispatch(setNextMonth());
  };

  return (
    <Container>
      <Button
        borderType={'square'}
        color={'filledWhiteStrong'}
        size={'md'}
        icon={{ position: 'left', size: 'Medium', fileName: 'AngleLeft', fill: '#505363' }}
        onClick={handlePrevMonthButtonClick}
      />

      <YearAndMonthWrapper>
        <YearAndMonth>{`${year}년 ${month}월 작업`}</YearAndMonth>
      </YearAndMonthWrapper>

      <Button
        borderType={'square'}
        color={'filledWhiteStrong'}
        size={'md'}
        icon={{ position: 'left', size: 'Medium', fileName: 'AngleRightTemp', fill: '#505363' }}
        onClick={handleNextMonthButtonClick}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const YearAndMonthWrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
`;

const YearAndMonth = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */

  align-self: stretch;
`;
